import axios from "axios";
import { gatherListRequest } from "./gatherListRequest";

const rangeParams = ({ days = 30, from, to } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (!from && !to) params.days = days === "all" || days === "custom" ? "all" : days;
  return params;
};

export async function fetchTrackSummary(user, { days = 30, from, to } = {}) {
  const { axiosConfig } = gatherListRequest(user);
  const res = await axios.get("/api/track/summary", {
    ...axiosConfig,
    params: rangeParams({ days, from, to }),
  });
  return res.data;
}

export async function fetchTrackEvents(user, { days = 30, from, to } = {}) {
  const { axiosConfig } = gatherListRequest(user);
  const res = await axios.get("/api/track/events", {
    ...axiosConfig,
    params: rangeParams({ days, from, to }),
  });
  return res.data;
}

/** Admin: remove one landing (or signup) for a browser session. */
export async function retractTrackEvent(
  user,
  { sessionId, event = "landing" } = {},
) {
  const { axiosConfig } = gatherListRequest(user);
  const res = await axios.post(
    "/api/track/retract",
    { sessionId, event },
    axiosConfig,
  );
  return res.data;
}

/** Admin: set displayed landing/signup totals (stored as an offset). */
export async function setTrackAdjustment(
  user,
  { landings, signups, days = 30, clear = false, note = "" } = {},
) {
  const { axiosConfig } = gatherListRequest(user);
  const body = clear
    ? { clear: true, days: days === "all" ? "all" : days }
    : {
        landings,
        signups,
        note,
        days: days === "all" ? "all" : days,
      };
  const res = await axios.post("/api/track/adjust", body, axiosConfig);
  return res.data;
}

export function trackSnapshotUrl(days = 30, { from, to } = {}) {
  const fromAxios = String(axios.defaults.baseURL || "").replace(/\/$/, "");
  const fallback =
    process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://api.ignite-elysium.com";
  const base = fromAxios || fallback;
  const params = new URLSearchParams(rangeParams({ days, from, to }));
  return `${base}/api/track/snapshot?${params.toString()}`;
}
